export const getSchedules = state => state.schedules;
export const getSchedulesData = state => state.schedules.data;
export const getSchedulesLoaded = state => state.schedules.loaded;
